import {HttpContextToken, HttpInterceptorFn} from "@angular/common/http";
import {inject} from "@angular/core";
import {LoadingService} from "../services/loading.service";
import {finalize} from "rxjs";

export const BYPASS_LOADING_INDICATOR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const loadingIndicatorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(BYPASS_LOADING_INDICATOR_INTERCEPTOR)) {
    return next(req);
  }

  const loadingService = inject(LoadingService);
  loadingService.setLoadingIndicator('increase');
  return next(req).pipe(
    finalize(() => loadingService.setLoadingIndicator('decrease'))
  );
};
